import React from 'react';
import TissueIcon from 'src/assets/images/TissueItemIcon.svg';
import NonTissueIcon from 'src/assets/images/NonTissueItemIcon.svg';
import NonTissueIconsmall from 'src/assets/images/NonTissueIconsmall.svg';
import TissueIconsmall from 'src/assets/images/TissueIconsmall.svg';
import {
    InvoiceDetailContainer,
    InvoiceDataContainer,
    OrderTypeSpanContianer,
    OrderCountContainer,
    OrderCountSpan,
    InvoiceStatusPrice,
} from './priceTags.styled';
import { setCurrencyFormat } from 'src/utils/util';

/*Accepts an array of prices, priceArray and a boolean, nonTissue to render the price tag.
Formatting to be done in the component using this.
Please pass required css properties as props as and when required to suit your needs.*/
const priceTag = (props) => {
    const priceSummation = (prevPrice, currentPrice) =>
        +prevPrice + +currentPrice;
    const totalPrice = props.priceArray?.reduce(priceSummation);
    return (
        <>
            {((props?.priceArray && props.priceArray.length > 0)|| props.isUsSurgeryT || props.isUsSurgeryNT) ? (
                <InvoiceDetailContainer
                    width={props.width}
                    mobileMarginTop={props.mobileMarginTop}
                    desktopMarginTop={props.desktopMarginTop}
                >
                    <InvoiceDataContainer
                        invoiceDataMargin={props.invoiceDataMargin}
                    >
                        {(props.isUSUser ) ? (
                            <OrderTypeSpanContianer
                                sourcePath={
                                    props.nonTissue ? NonTissueIcon : TissueIcon
                                }
                                ipadSourcePath={
                                    props.nonTissue
                                        ? props.isListView
                                            ? NonTissueIconsmall
                                            : NonTissueIcon
                                        : props.isListView
                                        ? TissueIconsmall
                                        : TissueIcon
                                }
                                marginRight={props.marginRightImage}
                                marginLeft={props.marginLeftImage}
                            >
                                {props.priceArray?.length>0 ? <OrderCountContainer
                                    display={props.countDisplay}
                                >
                                    <OrderCountSpan>
                                        {props.priceArray?.length}
                                    </OrderCountSpan>
                                </OrderCountContainer>:null}
                            </OrderTypeSpanContianer>
                         ) : null} 
                        {props.priceArray ? <InvoiceStatusPrice
                            fontFamily="AvenirNextWorld Demi"
                            fontSize={
                                props.currencyFont ? props.currencyFont : '12px'
                            }
                            isPrice={props.isPriceOverride}
                            isInvoiceStatus={props.isInvoiceStatus}
                            priceFontSize={props.priceFontSize}
                        >
                            {setCurrencyFormat(totalPrice)}
                        </InvoiceStatusPrice>:null}
                    </InvoiceDataContainer>
                </InvoiceDetailContainer>
            ) : null}
        </>
    );
};

export default priceTag;
